<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title>
            <span class="headline"
              >{{ newForm ? "Nova" : "Editar" }} Competência</span
            >
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-autocomplete
                    :items="power_plants"
                    item-text="name"
                    prepend-icon="flash_on"
                    label="Planta*"
                    v-model="power_plant"
                    return-object
                    :rules="[
                      (v) => !!v || 'Selecione a Planta que deseja ver fatura',
                    ]"
                    v-if="newForm"
                  ></v-autocomplete>
                  <v-text-field
                    v-model="power_plant.name"
                    :items="power_plants"
                    item-text="name"
                    label="Planta*"
                    disabled
                    v-if="!newForm"
                  />
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    v-model="competence"
                    :rules="competenceRules"
                    label="Competencia*"
                    prepend-icon="event"
                    class="purple-input"
                    :value="current_date"
                    mask="##/####"
                    :disabled="!newForm"
                  />
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="power_plant_amount"
                    :rules="powerPlantAmountRules"
                    label="Créditos Gerados*"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="power_plant_consumption_kW"
                    :rules="consumptionRules"
                    label="Consumo da Planta*"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="power_plant_custo_disp_kW"
                    :rules="consumptionRules"
                    label="Custo de Disponibilidade*"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model.number="number_of_customers"
                    :rules="customersRules"
                    label="Número de Membros*"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model.number="last_balance"
                    label="Saldo Anterior"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model.number="current_balance"
                    label="Saldo Atual"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="data_leitura_anterior"
                    label="Dia Leitura Anterior"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="data_leitura_atual"
                    label="Dia Leitura Atual"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="data_leitura_proxima"
                    label="Próxima Leitura"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model.number="dias_leitura"
                    label="Qtde Dias Leitura"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model.number="valor_conta"
                    label="Valor da Conta"
                    class="purple-input"
                  />
                </v-flex>
              </v-layout>
            </v-container>
            <small>*Campos obrigatórios</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.prevent="close()"
              >Cancelar</v-btn
            >
            <v-btn color="blue darken-1" flat @click="validate()">Salvar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
      <v-snackbar
        :color="color"
        :bottom="bottom"
        :top="top"
        :left="left"
        :right="right"
        v-model="snackbar"
        dark
      >
        <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
        <div>{{ snackMessage }}</div>
        <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
      </v-snackbar>
    </v-dialog>
  </v-layout>
</template>
<script>
import { EventBus } from "../../utils/event-bus";
import {
  // addInvoiceTotal,
  updateInvoiceTotal,
} from "../../services/invoices";
import { SET_BILLING_TOTAL } from "../../graphql/billing";

export default {
  props: ["power_plants"],
  data: () => ({
    dialog: false,
    competence: "",
    competenceRules: [
      (v) => !!v || "Por favor, preencher a competência da fatura.",
      (v) =>
        !(v.substr(2, 4) < 2019) ||
        "Por favor, o ano deve ser valido. " + v.substr(2, 4),
      (v) =>
        !(v.substr(0, 2) > 12) ||
        "Por favor, o mes deve ser valido. " + v.substr(0, 2),
    ],
    power_plant: "",
    power_plant_name: "",
    power_plant_id: "",
    power_plant_amount: 0,
    powerPlantAmountRules: [
      (v) => !!v || "Por favor, esse dado é obrigatório.",
      (v) => v > 0 || "Por favor, os valores devem ser maiores que zero.",
    ],
    power_plant_consumption_kW: 0,
    power_plant_custo_disp_kW: 0,
    number_of_customers: 0,
    consumptionRules: [
      (v) => !!v || "Por favor, esse dado é obrigatório.",
      (v) => v > 0 || "Por favor, os valores devem ser maiores que zero.",
    ],
    customersRules: [
      (v) => !!v || "Por favor, esse dado é obrigatório.",
      (v) => v > 0 || "Por favor, os valores devem ser maiores que zero.",
    ],
    last_balance: 0,
    data_leitura_anterior: "",
    data_leitura_atual: "",
    data_leitura_proxima: "",
    dias_leitura: 0,
    current_balance: 0,
    valor_conta: 0,
    current_date: new Date(),
    valid: false,
    loading: false,
    color: null,
    colors: ["purple", "info", "success", "warning", "error"],
    top: true,
    bottom: false,
    left: false,
    right: false,
    snackMessage: "",
    snackbar: false,
    totals: {},
    newForm: true,
  }),
  created() {
    EventBus.$on("showForm", (show) => {
      this.dialog = show;
    });
    EventBus.$on("totals", (totals) => {
      if (totals) {
        this.power_plant_id = totals.power_plant_id;
        this.power_plant_name = totals.power_plant.name;
        this.newForm = false;
        let year = totals.competence.split("-")[0];
        let month = totals.competence.split("-")[1];
        this.competence = month + "/" + year;
        this.power_plant = totals.power_plant;
        this.power_plant_amount = totals.power_plant_amount * 1;
        this.power_plant_consumption_kW = totals.power_plant_consumption_kW;
        this.power_plant_custo_disp_kW = totals.power_plant_custo_disp_kW;
        this.number_of_customers = totals.number_of_customers;
        this.last_balance = totals.last_balance;
        this.current_balance = totals.current_balance;
      }
    });
  },
  methods: {
    close() {
      this.dialog = false;
    },
    validate() {
      if (this.$refs.form.validate()) {
        const mes = this.competence.substr(0, 2);
        const ano = this.competence.substr(2, 4);
        const newCompetence = ano + "-" + mes;
        const power_plant_id =
          this.power_plant.PowerPlantId || this.power_plant_id;
        ((this.valid = true), (this.loading = true));
        const totals = {
          competence: newCompetence,
          power_plant_id: this.power_plant.power_plant_id,
          power_plant_amount: this.power_plant_amount * 1,
          power_plant_consumption_kW: this.power_plant_consumption_kW * 1,
          power_plant_custo_disp_kW: this.power_plant_custo_disp_kW * 1,
          number_of_customers: this.number_of_customers * 1,
          last_balance: this.last_balance * 1,
          current_balance: this.current_balance * 1,
          data_leitura_atual: this.data_leitura_atual,
          data_leitura_anterior: this.data_leitura_anterior,
          data_leitura_proxima: this.data_leitura_proxima,
          dias_leitura: this.dias_leitura,
          valor_conta: this.valor_conta,
        };
        let invoicetotal;
        if (this.newForm) {
          invoicetotal = this.addInvoiceTotal(totals);
        } else {
          invoicetotal = updateInvoiceTotal(
            power_plant_id,
            newCompetence,
            totals,
          );
        }
        invoicetotal
          .then(() => {
            this.snack("Competencia adicionada!", "success", "top");
            this.dialog = false;
          })
          .catch((error) => {
            console.error("Erro ao adicionar nova competencia! ", error);
            this.snack(
              "Erro ao adicionar a competencia! " + error,
              "error",
              "top",
            );
          });
      }
    },
    snack(message, color, ...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },
    addInvoiceTotal(total) {
      // Call to the graphql mutation
      return this.$apollo.mutate({
        // Query
        mutation: SET_BILLING_TOTAL,
        // Parameters
        variables: {
          competence: total.competence,
          power_plant_id: total.power_plant_id,
          power_plant_amount: total.power_plant_amount,
          power_plant_consumption_kW: total.power_plant_consumption_kW,
          power_plant_custo_disp_kW: total.power_plant_custo_disp_kW,
          number_of_customers: total.number_of_customers,
          last_balance: total.last_balance,
          current_balance: total.current_balance,
          data_leitura_atual: total.data_leitura_atual,
          data_leitura_anterior: total.data_leitura_anterior,
          data_leitura_proxima: total.data_leitura_proxima,
          dias_leitura: total.dias_leitura,
          valor_conta: total.valor_conta,
        },
        // Update the cache with the result
        // The query will be updated with the optimistic response
        // and then with the real result of the mutation
        /*
                update: (store, { data: { addTag } }) => {
                    // Read the data from our cache for this query.
                    const data = store.readQuery({ query: TAGS_QUERY })
                    // Add our tag from the mutation to the end
                    data.tags.push(addTag)
                    // Write our data back to the cache.
                    store.writeQuery({ query: TAGS_QUERY, data })
                },
                */
        // Optimistic UI
        // Will be treated as a 'fake' result as soon as the request is made
        // so that the UI can react quickly and the user be happy
        /*
                optimisticResponse: {
                    __typename: 'Mutation',
                    addTag: {
                    __typename: 'Tag',
                    id: -1,
                    label: newTag,
                    },
                },
                }).then((data) => {
                    // Result
                    
                    // console.log(data)
                    this.snack('Competencia adicionada!','success','top')
                    this.dialog = false
                }).catch((error) => {
                    // Error
                    console.error(error)
                    console.error('Erro ao adicionar nova competencia! ', error)
                    this.snack('Erro ao adicionar a competencia! ' + error,'error','top')
                })
                */
      });
    },
  },
};
</script>
